import React from "react";
import { Link } from "react-router-dom";
import { BOXES } from "../lib/site";

export default function Boxes() {
  return (
    <div data-testid="boxes-page" className="pt-32">
      <section className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="max-w-3xl">
          <div className="text-[11px] uppercase tracking-luxe text-gold mb-6">Subscription Boxes</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.95]">Three signature editions.<br/><span className="italic">One crown.</span></h1>
          <p className="mt-8 text-lg text-matte/70 font-light max-w-xl">Every box is intentionally curated to introduce you to exceptional Black-owned brands across haircare, skincare, beard care and self-care.</p>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 space-y-8">
          {BOXES.map((b, i) => (
            <div key={b.name} data-testid={`box-detail-${i}`} className="group grid md:grid-cols-5 gap-8 border-t border-taupe/50 pt-8">
              <div className="md:col-span-2 relative aspect-[4/5] md:aspect-auto overflow-hidden">
                <img src={b.img} alt={b.name} className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
                <div className="absolute top-4 left-4 px-3 py-1 bg-ivory text-matte text-[10px] uppercase tracking-luxe-sm">Coming Soon</div>
              </div>
              <div className="md:col-span-3 flex flex-col justify-center py-6">
                <div className="text-[11px] uppercase tracking-luxe text-gold">{b.tag}</div>
                <h2 className="font-serif text-4xl md:text-6xl mt-3">{b.name}</h2>
                <div className="gold-divider my-6" />
                <p className="text-matte/75 text-lg font-light leading-relaxed max-w-xl">{b.desc}</p>
                <ul className="mt-6 space-y-2 text-matte/70 text-base">
                  <li className="flex gap-3"><span className="text-gold">◆</span> 4–6 full-size premium products</li>
                  <li className="flex gap-3"><span className="text-gold">◆</span> Editorial brand storycard included</li>
                  <li className="flex gap-3"><span className="text-gold">◆</span> Beautifully packaged, gift-ready</li>
                </ul>
                <div className="mt-8">
                  <Link to="/waitlist" data-testid={`box-cta-${i}`} className="inline-block px-10 py-4 bg-matte text-gold border border-gold/40 text-[11px] uppercase tracking-luxe-sm hover:bg-black transition-colors">Notify Me at Launch</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
